<template lang="pug">
div
  div(v-if="has_permission")
    vm-row.heading(vm-w="12")
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected" :data="deliveryDeadlines")
            template(slot="header")
              .d-flex.justify-content-between
                div
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
              vm-th
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column != 'status' && column != 'total' && column != 'project_created_by'") {{data[indextr][column]}}
  #no-access(v-else)
    access-denied
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'DeliveryDates',
  data: () => ({
    selected: [],
    has_permission: true,
    delivery_deadlines_store_permission: true,
    columns: [
      'delivery_deadline',
      'delivery_deadline_comments'
    ]
  }),
  async created () {
    this.checkPermissionView('delivery_deadlines.update')
    this.$route.params.id && await this.getDeliveryDeadlines()
  },
  methods: {
    ...mapActions([
      'loadDeliveryDeadLines'
    ]),
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.delivery_deadlines_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'delivery_deadlines.update') > -1
    },
    async getDeliveryDeadlines () {
      this.loadDeliveryDeadLines(this.$route.params)
    }
  },
  computed: {
    ...mapGetters([
      'inOrder',
      'deliveryDeadlines'
    ])
  }
}
</script>
<style lang="scss">
  .separador-btn {
    margin: 10px 5px;
  }
  .filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
  }
  .con-vm-tooltip {
  display: inline-block;
  position: relative;
  }
  .vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
